// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Minimal custom styles — accent-color fallback for older browsers */
input[type='radio'][data-v-43b35f38],
input[type='checkbox'][data-v-43b35f38] {
  width: 14px;
  height: 14px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
